// import "./myApps.css";
import "../../../assets/scss/components/myApp.scss";
import React, { useState, useEffect } from "react";
import LoginService from "../../../services/login/loginService";
import {
  getAllApps,
  deleteApp,
  createApp,
  editApp,
} from "../../../services/MyApps/myAppServise";

import AppForm from "../../../components/ClientComponents/MyApp/AppForm";
import ErrorMsg from "../../../components/CommonCompnents/ErrorMsg";
import MyAppsComponent from "../../../components/ClientComponents/MyApp/MyAppsComponent";
import NoAppComponent from "../../../components/CommonCompnents/NoAppComponent";
import DeleteModal from "../../../components/ClientComponents/MyApp/DeleteModal";
import Loader from "../../../components/generic/loader";
import Analytics from "../../../components/ClientComponents/Analytics";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import {
  appNameValidate,
  redircetUrlValidate,
} from "../../../components/utils/formValidate";
import {
  constants,
  errorsMsg,
  removeServerErrors,
} from "../../Constants/commenFeatures";
import { MYAPP_TITLE } from "./myAppConstents";

const MyApp = () => {
  let [userId, setUserId] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const [noAppStatus, setNoAppStatus] = useState(false);
  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });
  const [appsData, setAppsData] = useState();
  const [createAppModal, setCreateAppModal] = useState({
    isOpen: false,
    title: "",
    appData: "",
  });
  const [deleteAppModal, setdeleteAppModal] = useState({
    isOpen: false,
    appData: "",
  });
  const [analyticsAppModal, setAnalyticsAppModal] = useState({
    isOpen: false,
    analyticsData: "",
  });
  const [showDND, setSetDND] = useState(true);
  const [createAppModalData, setCreateAppModalData] = useState({
    appName: "",
    redirectUri: "https://127.0.0.1/",
    appImage: "",
    imgView: "",
  });
  const [createFormError, setCreateFormError] = useState({
    appName: "",
    redirectUri: "",
    appImage: "",
    imgView: "",
  });

  //   Showing modals
  const updateCreateAppModalVal = (isOpen, title, appData) => {
    setCreateAppModal({
      isOpen: isOpen,
      title: title,
      appData: appData,
    });
  };

  const showDeleteModal = (val, app) => {
    setdeleteAppModal({
      isOpen: val,
      appData: app,
    });
  };

  const showAnalyticsModal = (val, app) => {
    setAnalyticsAppModal({
      isOpen: val,
      analyticsData: app,
    });
  };

  // Calling APis

  const myAppsRes = (res) => {
    if (res && res.data) {
      setNoAppStatus(false);
      setAppsData(res.data);
    } else {
      setNoAppStatus(true);
      setAppsData("");
    }
    setIsLoader(false);
  };

  const getMyApps = (userId) => {
    getAllApps(myAppsRes, userId);
  };

  const deleteAppsRes = async (res) => {
    if (res && res.data) {
      setIsServerErr({
        ...isServerErr,
        successRes: res.data.msg,
      });
      getMyApps(userId);
    } else if (res && res.error) {
      setIsServerErr({
        ...isServerErr,
        failedRes: res.error.errMsg || errorsMsg.commonError,
      });
    } else {
      setIsServerErr({
        ...isServerErr,
        failedRes: errorsMsg.commonError,
      });
    }
  };

  const deleteAppData = (app) => {
    deleteApp(deleteAppsRes, app);
    showDeleteModal(false);
  };

  const createAppRes = (res) => {
    if (res && res.error) {
      setIsLoader(false);
      setIsServerErr({
        ...isServerErr,
        failedRes: res.error.errMsg || errorsMsg.commonError,
      });
    } else if (res && res.data) {
      getMyApps(userId);
      setIsServerErr({
        ...isServerErr,
        successRes: res.data.msg,
      });
    } else {
      setIsServerErr({
        ...isServerErr,
        failedRes: errorsMsg.commonError,
      });
    }
  };

  const submitCreateAppForm = () => {
    updateCreateAppModalVal(false);
    if (appsData.actApps >= appsData.alwdActApps) {
      setIsServerErr({
        ...isServerErr,
        limitExceeded: "Only one Active app is allowed.",
      });
      return;
    } else {
      setIsLoader(true);
      const body = {
        appNm: createAppModalData.appName,
        rdUrl: window.btoa(createAppModalData.redirectUri),
      };

      if (createAppModalData.appImage !== "") {
        let reader = new FileReader();
        reader.readAsDataURL(createAppModalData.appImage);
        reader.onload = async () => {
          let baseImgUrl = await reader.result.split(",");
          body.flCntnt = baseImgUrl[1];
          body.flNm = createAppModalData.appImage.name;
          createApp(createAppRes, userId, body);
        };
        reader.onerror = () => {};
      } else {
        createApp(createAppRes, userId, body);
      }
    }
  };

  const editAppRes = (res) => {
    setIsLoader(false);

    if (res && res.error) {
      setIsServerErr({
        ...isServerErr,
        failedRes: res.error.errMsg || errorsMsg.commonError,
      });
    } else if (res && res.data) {
      getMyApps(userId);
      setIsServerErr({
        ...isServerErr,
        successRes: res.data.msg,
      });
    } else {
      setIsServerErr({
        ...isServerErr,
        failedRes: errorsMsg.commonError,
      });
    }
  };

  const editAppSubmit = () => {
    updateCreateAppModalVal(false);
    setIsLoader(true);
    const body = {
      oldAppNm: createAppModal.appData.appNm,
      newAppNm: createAppModalData.appName,
      rdUrl: window.btoa(createAppModalData.redirectUri),
      flCntnt: "",
      flNm: "",
    };
    if (createAppModalData.appImage !== "") {
      let reader = new FileReader();
      reader.readAsDataURL(createAppModalData.appImage);
      reader.onload = async () => {
        let baseImgUrl = await reader.result.split(",");
        body.flCntnt = baseImgUrl[1];
        body.flNm = createAppModalData.appImage.name;
        editApp(editAppRes, userId, body);
      };
    } else {
      editApp(editAppRes, userId, body);
    }
  };

  useEffect(() => {
    async function onPageLoad() {
      let userId = await LoginService.getUserID("userID");
      setUserId(userId);
      getMyApps(userId);
    }
    onPageLoad();
  }, []);

  // save create App Form Data
  const fillCreateAppForm = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (e.target.name === "appName") {
      let validateName = appNameValidate(e.target.value);
      if (validateName === true) {
        setCreateFormError({
          ...createFormError,
          [name]: "",
        });
      } else {
        setCreateFormError({
          ...createFormError,
          [name]: validateName,
        });
      }
    } else if (e.target.name === "redirectUri") {
      let validateRedirectUri = redircetUrlValidate(e.target.value);
      if (validateRedirectUri === true) {
        setCreateFormError({
          ...createFormError,
          [name]: "",
        });
      } else {
        setCreateFormError({
          ...createFormError,
          [name]: validateRedirectUri,
        });
      }
    }
    setCreateAppModalData({
      ...createAppModalData,
      [name]: value,
    });
  };

  const removeImage = () => {
    setCreateAppModalData({
      ...createAppModalData,
      appImage: "",
      imgView: "",
    });
  };

  const removeIsServerErrors = () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
  };

  useEffect(() => {
    if (createAppModal.title === MYAPP_TITLE.EDIT) {
      setCreateAppModalData({
        ...createAppModalData,
        appName: createAppModal.appData.appNm,
        redirectUri: createAppModal.appData.rdUrl,
        imgView: createAppModal.appData.flLnk
          ? appUrl.appIcon + createAppModal.appData.flLnk
          : "",
      });
    } else {
      setCreateAppModalData({
        appName: "",
        redirectUri: "https://127.0.0.1/",
        appImage: "",
        imgView: "",
      });
    }
  }, [createAppModal.appData]);

  useEffect(() => {
    if (createAppModal.isOpen === false) {
      setCreateFormError({
        appName: "",
        redirectUri: "",
        appImage: "",
        imgView: "",
      });
      setCreateAppModalData({
        appName: "",
        redirectUri: "https://127.0.0.1/",
        appImage: "",
        imgView: "",
      });
    }
  }, [createAppModal]);

  useEffect(() => {
    if (
      isServerErr.successRes !== "" ||
      isServerErr.failedRes !== "" ||
      isServerErr.limitExceeded !== ""
    ) {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);

  window.onclick = (e) => {
    e.preventDefault();
    let modal = document.getElementById("modal_analytics");
    if (e.target === modal) {
      showAnalyticsModal(false, "");
    }
  };

  return (
    <div>
      {isLoader ? (
        <div className="full_Loader">
          <Loader size={50} color="blue"></Loader>
        </div>
      ) : (
        <div>
          <ErrorMsg isServerErr={isServerErr} />
          <div>
            <div>
              {appsData && appsData.apps.length > 0 && !noAppStatus ? (
                <MyAppsComponent
                  appFormHandler={updateCreateAppModalVal}
                  appsData={appsData}
                  showDeleteModal={showDeleteModal}
                  showAnalyticsModal={showAnalyticsModal}
                  setIsServerErr={setIsServerErr}
                  isServerErr={isServerErr}
                />
              ) : (
                <NoAppComponent
                  appFormHandler={updateCreateAppModalVal}
                  title={MYAPP_TITLE.CREATE}
                />
              )}
            </div>
          </div>
          {/* Create App Modal */}

          <AppForm
            userId={userId}
            createAppModal={createAppModal}
            fillCreateAppForm={fillCreateAppForm}
            submitCreateAppForm={submitCreateAppForm}
            createAppModalData={createAppModalData}
            removeImage={removeImage}
            // appimageViewer={appimageViewer}
            setCreateAppModal={setCreateAppModal}
            updateCreateAppModalVal={updateCreateAppModalVal}
            setCreateAppModalData={setCreateAppModalData}
            editAppSubmit={editAppSubmit}
            createFormError={createFormError}
            setCreateFormError={setCreateFormError}
          />

          <Analytics
            analyticsAppModal={analyticsAppModal}
            showAnalyticsModal={showAnalyticsModal}
            userId={userId}
          />

          <DeleteModal
            deleteAppModal={deleteAppModal}
            showDeleteModal={showDeleteModal}
            deleteApp={deleteAppData}
          />
        </div>
      )}
    </div>
  );
};

export default MyApp;
